import Flickity from 'flickity';

export default {
  init($element) {

  },
  finalize($element) {

    const $btnPrev = $element.find('.button-prev');
    const $btnNext = $element.find('.button-next');

    const blockCarousel = new Flickity($element.find('.block-carousel').get()[0], {
      prevNextButtons: false,
      pageDots: false,
      cellAlign: 'left',
      wrapAround: true,
      autoPlay: 3000,
      pauseAutoPlayOnHover: false,
      on: {
        ready: function() {
          window.dispatchEvent(new Event('resize')); // Quickfix for sizing issue
        },
      },
    });

    $btnPrev.on('click', function() {
      blockCarousel.previous();
    });

    $btnNext.on('click', function() {
      blockCarousel.next();
    });

  },
}


// WEBPACK FOOTER //
// ./scripts/partials/ssg/testimonials.js